// src/components/ui/card.jsx
import React from "react";

export function Card({ children, className = "" }) {
  const base =
    "relative w-full rounded-2xl " +
    "bg-slate-800/65 " +                 // светлее
    "border border-slate-600/40 " +
    "shadow-lg shadow-black/20 " +
    "p-4 " +
    "transition-all duration-150";

  return <div className={`${base} ${className}`}>{children}</div>;
}

export function CardHeader({ children, className = "" }) {
  return <div className={`mb-3 flex items-start justify-between gap-2 ${className}`}>{children}</div>;
}

export function CardTitle({ children, className = "" }) {
  return (
    <h2 className={`text-[18px] font-bold text-white leading-snug ${className}`}>
      {children}
    </h2>
  );
}

export function CardContent({ children, className = "" }) {
  return <div className={className}>{children}</div>;
}
